export default __webpack_public_path__ + "static/media/sinsoftheflesh.36f05ed9.png";